import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { tk, bn, fmtDate } from "../lib/format";
import { Loader, Empty, GlassPage, GlassHeader } from "../components/kit";

export default function Reports() {
  const [list, setList] = useState<any[] | null>(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/day-close").then((r) => setList(r.data)); }, []);
  return (
    <GlassPage testid="reports-page">
      <GlassHeader title="দিন ক্লোজ রিপোর্ট" subtitle="প্রতিদিনের সারসংক্ষেপ রিপোর্টের তালিকা" />
      <div className="glass-card overflow-x-auto">
        {!list ? <Loader /> : list.length === 0 ? <Empty text="এখনো কোনো দিন ক্লোজ রিপোর্ট নেই। দৈনিক হিসাব পেজ থেকে 'দিন ক্লোজ' করুন।" /> : (
          <table className="w-full text-sm" data-testid="reports-table">
            <thead><tr className="text-slate-400 text-left border-b border-white/10"><th className="px-5 py-3 font-medium">রিপোর্ট নং</th><th className="px-3 py-3 font-medium">তারিখ</th><th className="px-3 py-3 font-medium text-right">বিক্রি</th><th className="px-3 py-3 font-medium text-right">আদায়</th><th className="px-3 py-3 font-medium text-right">মেমো</th><th className="px-5 py-3 font-medium text-right">নতুন বাকি</th></tr></thead>
            <tbody>
              {list.map((r) => (
                <tr key={r.id} className="border-b border-white/5 hover:bg-white/5 cursor-pointer" onClick={() => nav(`/reports/${r.id}`)} data-testid={`report-row-${r.report_no}`}>
                  <td className="px-5 py-3 font-semibold text-blue-300">{r.report_no}</td>
                  <td className="px-3 py-3 num text-slate-200">{fmtDate(r.date)}</td>
                  <td className="px-3 py-3 text-right num font-semibold text-white">{tk(r.total_sale)}</td>
                  <td className="px-3 py-3 text-right num text-emerald-300">{tk(r.total_collection)}</td>
                  <td className="px-3 py-3 text-right num text-slate-300">{bn(r.memo_count)}</td>
                  <td className="px-5 py-3 text-right num font-bold text-rose-300">{tk(r.total_due)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </GlassPage>
  );
}
